module.exports = __webpack_public_path__ + "img/2.3737ee3e.jpg";